// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".case-study-popup p{color:#afbbce;font-size:15px}.case-study-popup .case-study-thumbnail{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
